import { AnyAction } from '@reduxjs/toolkit'
import { Middleware } from 'redux'

import { addToFavorites, removeFromFavorites } from 'store/slices/favorites'
import { addProductInLocalList, removeItemInLocalList, removeLocalList } from 'store/slices/localProductsList'

import {
	addCompareItemSuccess,
	clearAllCategoryList,
	removeCompareItem,
	setActiveCategory
} from '@/features/compare/model/compareSlice'

import { isBrowserEnv } from '@/shared/lib/utils/next/isBrowserEnv'

export const NAME_OF_STATE_FIELD_IN_LOCAL_STORAGE = `applicationState`
// TODO localStorage.setItem обернуть в функцию
/**
 *
 * @param getState
 */
export const localStorageMiddleware: Middleware =
	({ getState }) =>
	next =>
	(action: AnyAction) => {
		const result = next(action)

		if (isBrowserEnv()) {
			const stateFromLocalStorage = localStorage.getItem(NAME_OF_STATE_FIELD_IN_LOCAL_STORAGE)

			// If it is compare action
			if (
				addCompareItemSuccess.match(action) ||
				removeCompareItem.match(action) ||
				setActiveCategory.match(action) ||
				clearAllCategoryList.match(action)
			) {
				// Save cart state to LS
				localStorage.setItem(
					NAME_OF_STATE_FIELD_IN_LOCAL_STORAGE,
					JSON.stringify({
						...(stateFromLocalStorage !== null ? JSON.parse(stateFromLocalStorage) : {}),
						compare: {
							...getState().compare,
							specFilter: `all`
						}
					})
				)
			}

			// If add/remove favorite product action
			if (addToFavorites.match(action) || removeFromFavorites.match(action)) {
				// Save cart state to LS
				localStorage.setItem(
					NAME_OF_STATE_FIELD_IN_LOCAL_STORAGE,
					JSON.stringify({
						...(stateFromLocalStorage !== null ? JSON.parse(stateFromLocalStorage) : {}),
						favorites: getState().favorites
					})
				)
			}

			if (addProductInLocalList.match(action) || removeItemInLocalList.match(action) || removeLocalList.match(action)) {
				localStorage.setItem(
					NAME_OF_STATE_FIELD_IN_LOCAL_STORAGE,
					JSON.stringify({
						...(stateFromLocalStorage !== null ? JSON.parse(stateFromLocalStorage) : {}),
						localProductsList: { ...getState().localProductsList }
					})
				)
			}
		}

		return result
	}
